import React, { useEffect, useState } from 'react';
import KitLoader from '../../components/kitsters/KitLoader';
import TableItem from "./TableItem"
import { getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';

const ItemNegativeStockCheck = () => {
  const [loading, setLoading] = useState(true);
  const [itemdatanegstock, setitemdatanegstock] = useState([]);

  const params = new URLSearchParams(window.location.search);

  const sendwhatsappmessage = async () => {
    $(".sendstatus").html(" | sending " + WAITINGGIF);
    
    let receiverphonenumber =  [
      {name:"viraj", "phonenumber":"919623078401"},
      {name:"aditi", "phonenumber":"919764786256"}, 
      {name:"nidhi", "phonenumber":"919822458030"},
      {name:"vikrant", "phonenumber":"919987284850"},
      {name:"poojan", "phonenumber":"919405447769"},
      {name:"vivek", "phonenumber":"917887516336"},
    ];

    await sendwhatsappmessageapi({
      message:"Fix issue with negative inventory - " + 
      " https://ssl.itpatil.com/inventory-report?adminuserid=6a043a73ef964e67e1c77ec0&appname=kitsters",
      receiverphonenumber:receiverphonenumber

    });
    $(".sendstatus").html(" | sending to: " + JSON.stringify(receiverphonenumber));
    setTimeout(() => {$(".sendstatus").html("")}, 2000);
  };

  const fetchdata = async () => {
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');
    let data = await getdatanoauth({ zohodatatype: 'items', _adminuserid: adminuserid, tag:"checknegativestock" }, '/zohodatanoauth');
    setitemdatanegstock(data.data);

    setLoading(false);
  };

  useEffect(() => {
   fetchdata();
  }, []);

  return (

    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}
      <h3 style={{ marginBottom: '16px' }}>Active items with −ve inventory | Problem Count: {itemdatanegstock.length} </h3>
      <TableItem itemdata={itemdatanegstock} />


    </div>
  );
};

export default ItemNegativeStockCheck;
